import { Badge } from '../../../shared/ui'
import type { PausedReason, ProgramStatRow } from '../../../lib/outreach/types'
import { capUsedPct, formatCount, pausedLabel } from '../../../lib/outreach/stats'
import { Section } from './Section'

function statusTone(reason: PausedReason | null): 'ok' | 'warn' | 'err' {
  if (!reason) return 'ok'
  return reason === 'bounce_stop' ? 'err' : 'warn'
}

function CapRow({ p }: { p: ProgramStatRow }) {
  const pct = capUsedPct(p.sent_today, p.cap_today)
  return (
    <li className="od-cap-row">
      <div className="od-name-cell">
        <span className="od-cap-name">{p.name}</span>
        <Badge>{p.kind}</Badge>
      </div>
      <div
        className="od-bar"
        role="progressbar"
        aria-label={`${p.name} daily cap used`}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={pct}
        aria-valuetext={`${formatCount(p.sent_today)} of ${formatCount(p.cap_today)} sent`}
      >
        <div className="od-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="od-cap-figures">
        {formatCount(p.sent_today)} / {formatCount(p.cap_today)}
      </span>
      <span className="od-cap-left">{formatCount(p.remaining)} left</span>
      <div>
        <Badge tone={statusTone(p.paused_reason)}>{pausedLabel(p.paused_reason)}</Badge>
      </div>
    </li>
  )
}

export function CapSection({ programs }: { programs: ProgramStatRow[] }) {
  return (
    <Section title="Today's cap" hint="Sent today counts first-touch emails only.">
      <ul className="od-cap-list" aria-label="Today's cap by program">
        {programs.map((p) => (
          <CapRow key={p.program_id} p={p} />
        ))}
      </ul>
    </Section>
  )
}
